// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-K3Nv3y","side":"side-exx7jG","future":"future-F96sWg","main":"main-ypR0Pa"};